import { render, staticRenderFns } from "./ParticipatingProducts.vue?vue&type=template&id=2a84043b&scoped=true"
import script from "./ParticipatingProducts.vue?vue&type=script&lang=js"
export * from "./ParticipatingProducts.vue?vue&type=script&lang=js"
import style0 from "./ParticipatingProducts.vue?vue&type=style&index=0&id=2a84043b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84043b",
  null
  
)

export default component.exports